export const SIGNIN_MASTER = "SIGNIN_MASTER";
export const SIGNIN_MASTER_SUCCESS = "SIGNIN_MASTER_SUCCESS";
export const SIGNIN_MASTER_FAILED = "SIGNIN_MASTER_FAILED";
export const SIGNIN_MASTER_RESET = "SIGNIN_MASTER_RESET";

// get user info
export const GET_USER_INFO = "GET_USER_INFO";
export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAILED = "GET_USER_INFO_FAILED";
export const GET_USER_INFO_RESET = "GET_USER_INFO_RESET";

//get notices
export const GET_NOTICES = "GET_NOTICES";
export const GET_NOTICES_SUCCESS = "GET_NOTICES_SUCCESS";
export const GET_NOTICES_FAILED = "GET_NOTICES_FAILED";
export const GET_NOTICES_RESET = "GET_NOTICES_RESET";

/**
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 */
export function actLogin(payload, onSuccess, onError) {
  return {
    type: SIGNIN_MASTER,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  };
}

export function actLoginSuccess(payload) {
  return {
    type: SIGNIN_MASTER_SUCCESS,
    payload: payload,
  };
}

export function actLoginFailed() {
  return {
    type: SIGNIN_MASTER_FAILED,
  };
}

export function actLoginReset() {
  return {
    type: SIGNIN_MASTER_RESET,
  };
}

// act get user info
/**
 * @param {object} payload
 * @param {function} onSuccess Callback function on success
 * @param {function} onError Callback function on error
 */
export function actGetUserInfo(payload, onSuccess, onError) {
  return {
    type: GET_USER_INFO,
    payload: payload,
    onSuccess: onSuccess,
    onError: onError,
  };
}

export function actGetUserInfoSuccess(payload) {
  return {
    type: GET_USER_INFO_SUCCESS,
    payload: payload,
  };
}

export function actGetUserInfoFailed() {
  return {
    type: GET_USER_INFO_FAILED,
  };
}

export function actGetUserInfoReset() {
  return {
    type: GET_USER_INFO_RESET,
  };
}

export default {
  actLogin,
  actLoginSuccess,
  actLoginFailed,
  actLoginReset,
  // act get user info
  actGetUserInfo,
  actGetUserInfoSuccess,
  actGetUserInfoFailed,
  actGetUserInfoReset,
};
